/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_RegistryInputs */

const cs_lustrace_history_registry = /** @type {(inputs: Lustrace_History_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registr`)
};

const en_lustrace_history_registry = /** @type {(inputs: Lustrace_History_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registry`)
};

/**
* | output |
* | --- |
* | "Registry" |
*
* @param {Lustrace_History_RegistryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_registry = /** @type {((inputs?: Lustrace_History_RegistryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_RegistryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_registry(inputs)
	return cs_lustrace_history_registry(inputs)
});